


























import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Swiper, { Navigation, SwiperOptions } from 'swiper'
import { mapGetters } from 'vuex'

Swiper.use( [Navigation] )

@Component( {
    computed: mapGetters( {
        images: 'imagesModule/images'
    } )
} )
export default class BaseImageTeaser extends Vue {
    $refs!: {
        sliderContainer: HTMLElement;
    }
    images: any
    currentImageId = ''
    slider: any
    sliderOptions: SwiperOptions = {
        centeredSlides: true,
        spaceBetween: 80,
        loop: true,
        containerModifierClass: 'oe-teaser__container-',
        slideClass: 'oe-teaser__slide',
        wrapperClass: 'oe-teaser__wrapper',
        observer: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
    }

    selectImage( imageId: string ) {
        this.$parent.$emit( 'imageSelected', imageId )
    }

    mounted () {
        this.currentImageId = Object.keys( this.images )[0]
        this.slider = new Swiper( this.$refs.sliderContainer, this.sliderOptions )
        this.slider.on( 'slideChange', ( swiper: Swiper ) => {
            this.currentImageId = ( swiper.slides[swiper.activeIndex] as HTMLElement ).dataset.id || ''
        } )
    }
}
